import { render } from "./RolesTabMenu.vue?vue&type=template&id=0887a2d1&scoped=true"
import script from "./RolesTabMenu.vue?vue&type=script&lang=js"
export * from "./RolesTabMenu.vue?vue&type=script&lang=js"

import "./RolesTabMenu.vue?vue&type=style&index=0&id=0887a2d1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0887a2d1"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn,QList,QItem,QItemSection,QItemLabel,QCheckbox,QInnerLoading});
